import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useToasts } from 'react-toast-notifications';
import { fetchAsyncTransactionInquiry } from 'redux/paymentSlice';

const useFetchTransactionInquiry = (paymentData, senderData, refetchPaymentDetails) => {
  const dispatch = useDispatch();
  const {addToast} = useToasts();
  const [isLoadingInquiry, setIsLoadingInquiry] = useState(false);

  const fetchTransactionInquiry = () => {
    setIsLoadingInquiry(true);
    const data = {
      paymentId: paymentData?._id,
      aggrId: senderData?.aggrId,
      corpId: senderData?.corpId,
      userId: senderData?.userId,
      urn: senderData?.urn,
      uniqueId: paymentData?.unqId,
    };

    dispatch(fetchAsyncTransactionInquiry(data))
      .then((res) => {
        if (res?.payload) {
          refetchPaymentDetails(); 
          const sts = res?.payload?.status;
          addToast(`Transaction status is ${sts}`, { appearance: "success" });
        } else {
          addToast(`${res?.error?.message}`, { appearance: "error" });
        }
      })
      .catch((error) => {
        addToast(`Error: ${error.message}`, { appearance: "error" });
      })
      .finally(() => {
        setIsLoadingInquiry(false);
      });
  };

  return { fetchTransactionInquiry, isLoadingInquiry };
};

export default useFetchTransactionInquiry;
